<template>
	<div
		:class="[
			gridColumnClasses,
			'grid px-4 divide-y-2 divide-gray-200 lg:divide-x-2 lg:divide-y-0 gap-y-12 lg:gap-y-0 lg:gap-x-0 lg:px-0'
		]"
	>
		<div
			v-for="(card, index) in cards"
			:key="card.title"
			class="flex flex-col px-4 lg:px-0 lg:pt-8"
		>
			<div
				:class="[
					'flex flex-col max-w-sm lg:pt-0',
					contentClasses,
					index === 0 ? 'pt-4 md:pt-10' : 'pt-12'
				]"
			>
				<component
					:is="card.icon"
					v-if="card.icon"
					class="w-20 h-20 mx-auto text-mx-orange"
				/>
				<h2 class="text-xl font-semibold text-gray-900">
					{{ card.title }}
				</h2>
				<p class="text-sm text-gray-500">
					{{ card.description }}
				</p>
			</div>
			<div :class="buttonMargin">
				<a
					v-if="card.href"
					:href="card.href"
					class="text-base font-medium transition-all duration-100 ease-in-out underline-offset-2 hover:underline decoration-mx-orange decoration-2 text-mx-orange"
					@click="handleCallUsClick"
				>
					{{ card.action }}
				</a>
				<button
					v-if="card.openChat"
					class="text-base font-medium transition-all duration-100 ease-in-out underline-offset-2 hover:underline decoration-mx-orange decoration-2 text-mx-orange"
					@click="openChat"
				>
					{{ card.action }}
				</button>
			</div>
			<slot name="additional-content" />
		</div>
	</div>
</template>

<script setup lang="ts">
import type { GA4Event } from '@/types/gtm/events'
import { useTrackEvent } from '@/composables/useEventTracking'
import { CONTACT_CALL_US_CLICK } from '@/constants/gtm/events.js'
import type { ContactCardProps } from '@/components/contact/types'

const props = defineProps({
	cards: {
		type: Array as PropType<ContactCardProps[]>,
		required: true
	},
	gridColumnClasses: {
		type: String,
		default: 'grid-cols-1 lg:grid-cols-2'
	},
	buttonMargin: {
		type: String,
		default: 'mt-auto'
	},
	contentClasses: {
		type: String,
		default: 'pb-6 lg:pb-12 space-y-4'
	}
})

const { cards } = toRefs(props)

const handleCallUsClick = () => {
	const trackedEvent: GA4Event = {
		event: CONTACT_CALL_US_CLICK,
		category: 'Contact',
		action: 'click',
		label: 'Contact - Call Us Click'
	}
	useTrackEvent(trackedEvent)
}
</script>
